import { useRef } from 'react';

import { Field, getFieldValue, RichText, Text, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'lib/ComponentProps';

import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import ChevronDownSvg from 'public/icons/ChevronDown.svg';

import styles from './TextBlock.module.css';

type TextBlockProps = ComponentProps & {
	fields: {
		Title: Field<string>;
		Information: Field<string>;
		Expandable: Field<boolean>;
	};
};

export default withDatasourceCheck()<TextBlockProps>(TextBlock);

function TextBlock(props: TextBlockProps): JSX.Element {
	const isEditing = IsSitecoreEditing();
	const isExpandable = getFieldValue(props.fields, 'Expandable', false);
	const headerRef = useRef<HTMLHeadingElement>(null);
	const bodyRef = useRef<HTMLDivElement>(null);

	function toggleCollapsible() {
		const headerEl = headerRef.current;
		const bodyEl = bodyRef.current;

		if (!bodyEl || !headerEl) {
			return;
		}

		if (bodyEl.offsetHeight === 0) {
			bodyEl.style.height = `${bodyEl.scrollHeight}px`;

			headerEl.classList.add('open');
		} else {
			bodyEl.style.height = '0px';

			headerEl.classList.remove('open');
		}
	}

	const info = (
		<div className={styles.info} style={{ height: isExpandable && !isEditing ? 0 : '' }} ref={bodyRef}>
			<RichText field={props.fields?.Information} className={styles.richtext} />
		</div>
	);

	if (!props.fields?.Title && !isEditing) {
		return <section>{info}</section>;
	}

	return (
		<section className={`${styles.section} padX maxWidth`} data-display-pdf-download>
			<h3
				className={`${styles.header} ${!props.fields.Title?.value ? styles.hide : ''}`}
				onClick={() => (isExpandable && !isEditing ? toggleCollapsible() : undefined)}
				ref={headerRef}
			>
				{isExpandable && <ChevronDownSvg className={styles.icon} />}

				<Text field={props.fields?.Title} />
			</h3>

			{info}
		</section>
	);
}
